import React from 'react';

const RentalHistoryTab = () => {
  return (
    <div>
      
    </div>
  );
};

RentalHistoryTab.propTypes = {};

export default RentalHistoryTab;
